import { supabase } from './supabase';

export async function checkEmailUnique(email: string, excludeId?: string): Promise<boolean> {
  let query = supabase
    .from('doctors')
    .select('id')
    .eq('email', email);
  
  if (excludeId) {
    query = query.neq('id', excludeId);
  }
  
  const { data, error } = await query;
  if (error) throw error;
  
  return data.length === 0;
}

export async function checkLicenseUnique(license_no: string, excludeId?: string): Promise<boolean> {
  let query = supabase
    .from('doctors')
    .select('id')
    .eq('license_no', license_no);
  
  if (excludeId) {
    query = query.neq('id', excludeId);
  }
  
  const { data, error } = await query;
  if (error) throw error;
  
  return data.length === 0;
}

export async function getSpecializations(): Promise<string[]> {
  const { data, error } = await supabase
    .from('doctors')
    .select('specialization')
    .not('specialization', 'is', null);
  
  if (error) throw error;
  
  const unique = [...new Set(data.map(d => d.specialization))];
  
  if (unique.length === 0) {
    return [
      'Cardiology',
      'Dermatology',
      'Emergency Medicine',
      'Endocrinology',
      'Gastroenterology',
      'General Medicine',
      'Neurology',
      'Oncology',
      'Orthopedics',
      'Pediatrics',
      'Psychiatry',
      'Radiology',
      'Surgery',
    ];
  }
  
  return unique.sort();
}

export async function getDepartments(): Promise<string[]> {
  const { data, error } = await supabase
    .from('doctors')
    .select('department')
    .not('department', 'is', null);
  
  if (error) throw error;
  
  const unique = [...new Set(data.map(d => d.department))];
  
  if (unique.length === 0) {
    return [
      'Cardiology',
      'Dermatology',
      'Emergency',
      'Endocrinology',
      'Gastroenterology',
      'General Medicine',
      'Neurology',
      'Oncology',
      'Orthopedics',
      'Pediatrics',
      'Psychiatry',
      'Radiology',
      'Surgery',
    ];
  }
  
  return unique.sort();
}

export const AVAILABLE_PRIVILEGES = [
  'admit',
  'prescribe_narcotics',
  'order_labs',
  'order_radiology',
  'perform_procedures',
  'discharge_approve',
];
